import axios from "../../axios";
import * as routes from "../../api-routes/Manager/Analytics";

export const getSalesGraphReq = (token, queryParams) => {
  return axios.get(
    `${process.env.REACT_APP_DASHBOARD_ENDPOINT}${routes.getSalesChart}`,
    {
      params: {
        ...queryParams,
      },
      headers: {
        token,
      },
    }
  );
};
